import { put, takeEvery, takeLatest, call } from '@redux-saga/core/effects';
import {
  login,
  login_error,
  login_success,
  request_token,
  request_token_error,
  reset_password,
  reset_password_error,
  sign_up,
  sign_up_error,
  verify_email,
  verify_email_error,
  sign_up_google,
  sign_up_google_error,
  // login_google,
  // login_google_success,
  // login_google_error
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';

function* loginSaga({ payload }) {
  try {
    const requestRes = yield call(api.post, '/auth/login', payload);
    const responseData = requestRes.data;
    const user = responseData.data.user;
    if (user.email_verified) {
      localStorage.setItem('x-access-token', responseData.data.token);
      localStorage.setItem('user', JSON.stringify(responseData.data.user));
      yield put({
        type: login_success.type,
        payload: user,
      });

      if (window?.location?.pathname !== '/basket') {
        window.location.href = `/marketplace`;
      } else {
        window.location.reload();
      }
    } else {
      const response = yield call(api.get, '/auth/request-email-otp');
      toast.success(response.message);
      window.location.href = '/otp';
    }
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: login_error.type,
    });
  }
}

function* signupSaga({ payload }) {
  try {
    const requestRes = yield call(api.post, '/auth/signup', payload);
    const responseData = requestRes.data;
    localStorage.setItem('x-access-token', responseData.data.token);
    localStorage.setItem('email', payload.email);
    window.location.href = '/otp';
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: sign_up_error.type,
    });
  }
}

function* signupGoogleSaga() {
  try {
    const requestRes = yield call(api.post, '/auth/googlesignup');
    const responseData = requestRes.data;
    console.log(responseData.data);
    // localStorage.setItem('x-access-token', responseData.data.token);
    // localStorage.setItem('email', payload.email);
    // window.location.href = '/otp';
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: sign_up_google_error.type,
    });
  }
}

function* verifyEmailSaga({ payload }) {
  try {
    const requestRes = yield call(api.patch, '/auth/verify-email', payload);
    const responseData = requestRes.data;
    localStorage.removeItem('email');
    if (responseData.success && responseData.status_code === 200) {
      window.location.href = '/login';
    }
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: verify_email_error.type,
    });
  }
}

function* requestNewPasswordTokenSaga({ payload }) {
  try {
    const requestRes = yield call(api.patch, '/auth/forgot-password', payload);
    const responseData = requestRes.data;
    if (responseData.success && responseData.status_code === 200) {
      toast.success('Password reset token was sent to your email');
      window.location.href = `/reset-password?email=${responseData.data.email}`;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: request_token_error.type,
    });
  }
}

function* resetPasswordSaga({ payload }) {
  try {
    const requestRes = yield call(api.patch, '/auth/reset-password', payload);
    const responseData = requestRes.data;
    if (responseData.success && responseData.status_code === 200) {
      toast.success('Password reset successful, redirecting to login');
      window.location.href = `/login`;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: reset_password_error.type,
    });
  }
}

function* authSagas() {
  yield takeEvery(login.type, loginSaga);
  yield takeLatest(sign_up.type, signupSaga);
  yield takeLatest(verify_email.type, verifyEmailSaga);
  yield takeLatest(request_token.type, requestNewPasswordTokenSaga);
  yield takeLatest(reset_password.type, resetPasswordSaga);
  yield takeLatest(sign_up_google.type, signupGoogleSaga);
}

export default authSagas;
